import style from './Carregando.module.css';

// Indicador de carregamento só com CSS (substitui o react-loading-indicators, ~100KB no bundle)
// tipo 'pontos': três pontos pulando | tipo 'circulo': anel girando
export default function Carregando({ tipo = 'pontos' }) {
    if (tipo === 'circulo') {
        return <div className={style.circulo} role="status" aria-label="Carregando" />;
    }
    return (
        <div className={style.pontos} role="status" aria-label="Carregando">
            <span />
            <span />
            <span />
        </div>
    );
}
